import { useContext, useCallback, useState, useMemo } from "react"
import MaskDressform from "../components/MaskDressform/MaskDressform"
import MaskModel from "../components/MaskModelWithBgMoveable"
// import MaskModel from "../components/MaskModel/MaskModel"
import UploadModelAndCommodity from "../components/UploadModelAndCommodity"
import { IMAGE_TYPE } from '@utils/CONST'
import { GenerateContext } from "@utils/GenerateContext"
import { Upload } from "antd"
import styles from "./index.module.scss"
import Utils from "@utils/utils"
import useResizeObserver from "@utils/useResizeObserver"
import exampleJSON from '@assets/shoes_example/example.json'

const SubCompShoes = (props) => {
    const {
        imgRatio,
        inputImage,
        maskMoveable,
        rightProjectId,
        setGlobaluploadLoading
    } = useContext(GenerateContext)

    const uploadDebounce = useCallback(_.debounce(async (file, fileList) => {
        console.log('===uploadDebounce===')
        setGlobaluploadLoading(true)
        await props.reUpload(file)
    }, 100), [])

    const handleDrop = async (e) => {
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            if (filesAndDirs.length == 0) return false
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList)
            return false
        }
    }

    const [wrapWidth, setWrapWidth] = useState(0)
    const [wrapHeight, setWrapHeight] = useState(0)
    const targetRef = useResizeObserver((entries) => {
        for (let entry of entries) {
            // 处理尺寸变化的逻辑
            setWrapWidth(entry.contentRect.width)
            setWrapHeight(entry.contentRect.height)
        }
    })

    const sampleVisible = useMemo(() => {
        if (rightProjectId) return false
        if (wrapWidth < 680) {
            return false
        } else return true
    }, [wrapWidth, rightProjectId])

    const ExampleContent = (props) => {
        const data = exampleJSON.SHOES

        return (
            <div className={`${styles.ExampleContent} ${styles[props.direction]}`}>
                <div style={{ backgroundColor: '#fff' }}>
                    <img src={require(`@assets/shoes_example/${data[`correct_img`]}`)} />
                </div>
            </div>
        )
    }


    return (
        <div className={styles.Content} ref={targetRef}>
            <div className={styles.ContentUpload}>
                {
                    props.segmentResult?.length > 0 ?
                        <Upload.Dragger
                            accept={'image/jpeg,image/png,image/webp,image/avif'}
                            name="avatar"
                            showUploadList={false}
                            className={styles.UploadWrap}
                            maxCount={1}
                            beforeUpload={() => false}
                            onDrop={handleDrop}
                        >
                            <div style={{ width: "100%", height: "100%", cursor: "default" }} onClick={e => e.stopPropagation()}>
                                {
                                    <MaskDressform
                                        border
                                        key={props.segmentResult[0]}
                                        imageType={IMAGE_TYPE.SHOES}
                                        aiInteractiveNpy={props.aiInteractiveNpy}
                                        segmentResult={props.segmentResult}
                                        reUpload={props.reUpload}
                                        deleteOpt={props.deleteOpt}
                                        mattingOpt={props.mattingOpt}
                                        composeOpt={props.composeOpt}
                                        onNpyChange={props.onNpyChange}
                                    />
                                }
                            </div>
                        </Upload.Dragger>
                        :
                        <UploadModelAndCommodity
                            imageType={props.imageType}
                            onBeforeUpload={props.onBeforeUpload}
                        />
                }
            </div>

            <div className={`${styles.ContentSample} ${!sampleVisible && styles.hidden}`}>
                <ExampleContent direction="vertical" />
            </div>

        </div>


    )
}

export default SubCompShoes